import React, { useState } from "react";
import logo from "../assets/vignan_online.png";
import axios from "axios";
import { useNavigate } from 'react-router-dom';


const ExternalRegister = () => {
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [name, setName] = useState("");
    const [error, setErrror] = useState("")
    const navigate = useNavigate();

    async function registeruser(e) {
        e.preventDefault();
        await axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/api/users/signup/external`, {
                first_name: name,
                email: email,
                phone_number: phone
            })
            .then((resp) => {
                if (resp.status === 201) {
                    setTimeout(() => {
                        setName("")
                        setEmail("")
                        setPhone("")
                    }, 2000)
                }
                navigate('/login');
            })
            .catch((error) => {
                setErrror(error.response.data.message)
                setTimeout(() => {
                    setErrror("")
                }, 2000)

            });
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden border border-gray-100 relative">

                <div className="p-8 pb-6">
                    <a href="/" className="block w-max mx-auto mb-8 transition-transform hover:scale-105 duration-300">
                        <img src={logo} alt="Vignan Online" className="h-12 object-contain" />
                    </a>

                    <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">Create Account</h2>
                    <p className="text-center text-gray-500 mb-8 text-sm">Signup to access your dashboard</p>

                    <form onSubmit={registeruser} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">Full Name</label>
                            <InputField
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter your full name"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">Email Address</label>
                            <InputField
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                                placeholder="yourname@example.com"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1 ml-1 text-left">Phone Number</label>
                            <InputField
                                type="tel"
                                value={phone}
                                onChange={(e) => {
                                    const input = e.target.value.replace(/\D/g, "");
                                    if (input.length <= 10) {
                                        setPhone(input);
                                    }
                                }}
                                placeholder="Enter 10-digit number"
                                maxLength={10}
                                required
                            />
                        </div>

                        {error && (
                            <div className="text-red-500 text-sm text-center bg-red-50 py-2 rounded">
                                {error}
                            </div>
                        )}

                        <div className="pt-2">
                            <PrimaryButton type="submit">
                                Register
                            </PrimaryButton>
                        </div>
                    </form>

                    <div className="mt-8 text-center">
                        <p className="text-gray-500 text-sm">
                            Already have an account?{' '}
                            <a href="/login" className="text-red-600 font-semibold hover:text-red-700 transition-colors">
                                Login here
                            </a>
                        </p>
                    </div>
                </div>

                <div className="bg-gray-50 px-8 py-4 text-center border-t border-gray-100">
                    <p className="text-xs text-gray-400">
                        © {new Date().getFullYear()} VIGNAN Online (Deemed to be University). All Rights Reserved.
                    </p>
                </div>
            </div>
        </div>
    )

}

// Design Components
const InputField = ({ type, placeholder, value, onChange, ...props }) => (
    <input
        type={type}
        value={value}
        onChange={onChange}
        className={`w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition-all duration-200 bg-gray-50 focus:bg-white placeholder-gray-400 text-gray-800 ${props.className || ''}`}
        placeholder={placeholder}
        {...props}
    />
);

const PrimaryButton = ({ children, onClick, disabled, className, type = "submit" }) => (
    <button
        onClick={onClick}
        type={type}
        disabled={disabled}
        className={`w-full py-3 px-4 rounded-lg bg-red-600 hover:bg-red-700 text-white font-semibold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none flex justify-center items-center ${className || ''}`}
    >
        {children}
    </button>
);

export default ExternalRegister;